import api from "./api";
import { readPortalPayrollError } from "./portalPayrollErrors";
import {
  EMPTY_PORTAL_PAYROLL_UPDATE_SUMMARY,
  PortalPayrollUpdateResult,
} from "./portalPayrollUpdateRows";

export type {
  PortalPayrollUpdateFilter,
  PortalPayrollUpdateResult,
  PortalPayrollUpdateRow,
  PortalPayrollUpdateRowStatus,
  PortalPayrollUpdateSummary,
} from "./portalPayrollUpdateRows";
export { filterPortalPayrollUpdateRows } from "./portalPayrollUpdateRows";

export const updatePortalPayrollRecords = async (
  processId: string
): Promise<PortalPayrollUpdateResult> => {
  const userId = sessionStorage.getItem("usuarioId") ?? "";
  if (!userId) throw new Error("No se pudo identificar al usuario de la sesión.");
  if (!processId) throw new Error("No hay un procesamiento vigente para actualizar.");

  let response: any;
  try {
    response = await api.post(
      `excel/update/nomina-portales?userId=${encodeURIComponent(userId)}`,
      { processId }
    );
  } catch (error) {
    throw new Error(await readPortalPayrollError(error));
  }

  const data = response?.data ?? {};
  return {
    updateId: typeof data.updateId === "string" ? data.updateId : "",
    processId: typeof data.processId === "string" ? data.processId : processId,
    summary: { ...EMPTY_PORTAL_PAYROLL_UPDATE_SUMMARY, ...(data.summary ?? {}) },
    rows: Array.isArray(data.rows) ? data.rows : [],
  };
};
